import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PaymentSetupForm from './PaymentSetupForm';
import { useAuth } from '../contexts/AuthContext';

// Plan choice + Stripe card form in a dialog, so nobody has to leave the page they are on to purchase.
// fixedPlans: show the monthly/annual card even when a per-flat price is configured
const PaymentDialog: React.FC<{ open: boolean; onClose: () => void; onPaid?: () => void; fixedPlans?: boolean }> = ({ open, onClose, onPaid, fixedPlans }) => {
  const { refreshSubscriptionStatus } = useAuth();

  const handleSuccess = async () => {
    await refreshSubscriptionStatus();
    onClose();
    onPaid?.();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 4, position: 'relative' }}>
        <IconButton aria-label="Close" onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <PaymentSetupForm onSuccess={handleSuccess} fixedPlans={fixedPlans} />
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
